'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h400c17.674 0 32-14.326 32-32s-14.326-32-32-32h-400c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224c0-14.332-4.372-39.35-42.194-90.924zM704 256v-153.946c22.984 17.78 50.678 41.878 81.374 72.574 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z' }),
        React.createElement('path', { d: 'M1024 768h-128v-128h-128v128h-128v128h128v128h128v-128h128z' })
    ));
};